import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const deleteSetKeys = {
    wrapper: generateAutomationName("settings", ["delete", "set", "wrapper"]),
    subTitle: generateAutomationName("settings", ["delete", "set", "subTitle"]),
};
